import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=5b744d4b&scoped=true&"
import script from "./NewsDetail.vue?vue&type=script&lang=js&"
export * from "./NewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=5b744d4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b744d4b",
  null
  
)

export default component.exports